







































































import Component from "vue-class-component";
import Vue from "vue";
import { PolicyTransactionDto } from "../../../api/ClientPortalApiClient";
import { Prop } from "vue-property-decorator";
import ApiFactory from "@/api/ApiFactory";
import { FormatDate } from "../../../filters/FormatDate";
import { LoadingSpinnerService } from "@/store";

@Component({})
export default class PolicyTransactions extends Vue {
  @Prop() policyId: number | undefined;
  private transactions: PolicyTransactionDto[] | null = [];
  private filterString: string | null = "";
  private fields = [
    {
      key: "transactionType",
      label: "Type",
      sortable: false
    },
    {
      key: "transactionDate",
      label: "Date",
      sortable: true
    },
    {
      key: "transactionAmount",
      label: "Amount",
      sortable: false,
      formatter: (value: any, key: any, item: any) =>
        value.toLocaleString("en-IE", { style: "currency", currency: "EUR" })
    },
    {
      key: "balance",
      label: "Balance",
      sortable: false,
      formatter: (value: any, key: any, item: any) =>
        value.toLocaleString("en-IE", { style: "currency", currency: "EUR" })
    },
    {
      key: "transactionNotes",
      label: "Notes",
      sortable: false
    }
  ];
  async mounted() {
    await this.getPolicyTransactions();
  }

  private async getPolicyTransactions() {
    if (!this.policyId) throw new Error("Policy id not valid");
    const api = ApiFactory.CreateDataClient();
    this.transactions = await api.policyTransactions_GetByPolicyId(
      this.policyId
    );

    if (this.transactions) {
      for (var i = 0; i < this.transactions.length; i++) {
        this.transactions[i].transactionDate = FormatDate.format(
          this.transactions[i].transactionDate
        );
      }
    }
  }

  private base64ToArrayBuffer(base64: string) {
    var binaryString = window.atob(base64);
    var binaryLen = binaryString.length;
    var bytes = new Uint8Array(binaryLen);
    for (var i = 0; i < binaryLen; i++) {
      var ascii = binaryString.charCodeAt(i);
      bytes[i] = ascii;
    }
    return bytes;
  }

  private async DownloadPolicyTransaction() {
    LoadingSpinnerService.Show("Creating Policy Transaction...");
    try {
      if (!this.policyId) throw new Error("Policy id not valid");
      const api = ApiFactory.CreateDataClient();
      const data = await api.externalBroker_DownloadPolicyTransaction(
        this.policyId
      );
      if (data.data && data.fileName) {
        var bytes = this.base64ToArrayBuffer(data.data);
        const blob = new Blob([bytes], { type: data.contentType });
        var link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        var fileName = data.fileName;
        link.download = fileName;
        LoadingSpinnerService.Hide();
        link.click();
      }
    } catch (error) {
      LoadingSpinnerService.Failure("Something went wrong. Please try again.");
    }
  }

  private async downloadPolicyTransactionsData() {
    LoadingSpinnerService.Show("Downloading transaction history...");
    try {
      if (!this.policyId) throw new Error("Policy id not valid");
      const api = ApiFactory.CreateDataClient();
      const data = await api.externalBroker_DownloadPolicyTransactionData(
        this.policyId
      );
      if (data.data && data.fileName) {
        var bytes = this.base64ToArrayBuffer(data.data);
        const blob = new Blob([bytes], { type: data.contentType });
        var link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        var fileName = data.fileName;
        link.download = fileName;
        LoadingSpinnerService.Hide();
        link.click();
      }
    } catch (error) {
      LoadingSpinnerService.Failure("Something went wrong. Please try again.");
    }
  }
}
